export { default } from "./PartTablePagination";
